<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Veranstaltung bearbeiten">
      <event-form
        :loading="loading"
        :event="event"
        :form-submitted="saveEvent"
        :submit-label="submitLabel"
        :pretix-disconnecting="pretixDisconnecting"
        mode="edit"
        @disconnect-pretix="disconnectPretix"
      ></event-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import EventForm from "@/components/forms/EventForm"
import OrganizationEventsRepository from "@/repositories/organization/events_repository.js"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"
import MessagesMixin from "@/mixins/messages.js"

export default {
  components: {
    TheBreadcrumbs,
    PageContent,
    EventForm
  },
  mixins: [ApiErrorHandlerMixin, MessagesMixin],
  data() {
    return {
      loading: true,
      pretixDisconnecting: false,
      event: {
        connect_to_pretix: false,
        dates_attributes: []
      }
    }
  },
  computed: {
    submitLabel() {
      return this.event.status === "needs_edit"
        ? "Überarbeitung abschicken"
        : "Änderungen speichern"
    }
  },
  async created() {
    try {
      const fetchedEvent = await OrganizationEventsRepository.get(
        this.$route.params.id
      )
      this.event = {
        connect_to_pretix: false,
        dates_attributes: [],
        ...fetchedEvent
      }
      this.loading = false
    } catch (error) {
      this.loading = false
      this.handleApiError(error)
    }
  },
  methods: {
    async saveEvent(event) {
      await OrganizationEventsRepository.update(event.id, event)
      try {
        await this.$router.push({
          name: "EventsPage",
          query: { allow_redirect: true }
        })
      } catch {
        //
      }
    },
    async disconnectPretix() {
      try {
        await this.$confirm(
          "Möchten Sie die Pretix-Verknüpfung für diese Veranstaltung wirklich aufheben?" +
            "<br>Dadurch wird die Verbindung zur Pretix-Veranstaltung dauerhaft getrennt." +
            "<br>Die bisherige Anmelde-URL über Pretix wird nicht mehr in der Familien.app angezeigt." +
            "<br><br>Die Pretix-Veranstaltung selbst und bereits bestehende Bestellungen bleiben in Pretix erhalten, werden aber nicht mehr synchronisiert.",
          "Verknüpfung aufheben",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Aufheben",
            cancelButtonText: "Abbrechen",
            type: "warning"
          }
        )
      } catch {
        return // User cancelled
      }

      this.pretixDisconnecting = true
      try {
        await OrganizationEventsRepository.disconnectPretix(this.event.id)
        this.event.pretix_connected = false
        this.event.pretix_organizer_slug = null
        this.event.pretix_event_slug = null
        this.event.pretix_event_url = null
        this.event.connect_to_pretix = false
        this.showCustomMessage(
          "Pretix-Verknüpfung wurde erfolgreich aufgehoben.",
          "success"
        )
      } catch (error) {
        this.handleApiError(error)
      } finally {
        this.pretixDisconnecting = false
      }
    }
  }
}
</script>
